// Public website settings. Use the actual approved filing number and official
// mini-program assets when available; empty values render honest launch states.
export const SITE = {
  url: 'https://www.focusfollow.cn',
  studioUrl: '', // Public workbench URL, once the business service is deployed.
  operator: '',
  icpNumber: '',
  publicSecurityNumber: '',
  publicSecurityUrl: '',
  miniProgramCode: '', // Local public asset path, e.g. /images/miniprogram-code.jpg.
  miniProgramUrl: '', // Official WeChat URL Link; leave empty until available.
} as const;
